// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"cd442c47","532":"e2b01cd9"}[chunkId] + ".chunk.js";
};